/* Por conta da casa (out/2026): brindes sem app, por estoque (v261, 20/10). O brinde e um produto proprio de R$ 0,00 (tag brinde-campanha, oculto), com o codigo do cadastro BRINDE PROMOCIONAL do Bling: nao soma no frete gratis e a nota sai como bonificacao. Esgotaram tampo de vidro, kits de prateleiras, mesa de centro, 2 cestos e o porta-sabonete. Seguem o kit de 3 nichos freijo (rack, painel e aparador em qualquer cor) e porta-algodao com bandeja (armarios e Milano com armario). Cortesia por valor da caixa: 1 a partir de R$ 1.500 e 2 a partir de R$ 2.500. Liga em 07/10 e desliga sozinho em 31/10. Teste: ?brindes=teste na URL. */
(function () {
'use strict';
var IMG = 'https://cdn.shopify.com/s/files/1/0552/8741/4922/files/';
var C = {
grupos: {
solo60: '20312 20313 20112 20113', solo80: '20322 20323 20122 20123', solo50: '20212 20213 20210 20211',
msolo60: '20412 20413', msolo80: '20422 20423',
combo60: '20310 20311 20326 20328 20330 20332 20110 20111 20125 20126 20127 20128',
combo80: '20320 20321 20327 20331 20329 20333 20120 20121 20129 20130 20131 20132',
mil60: '20410 20411 20427 20429 20431 20433 20435 20440 20442 20443 20444 20445 20452 20455 20462 20466',
mil80: '20420 20421 20428 20430 20432 20434 20436 20439 20446 20447 20448 20449 20456 20459 20463 20467',
arm: '20314 20324 20114 20124 20214 20414 20424 20500 20501 20502 20503 20504 20505',
rack: '10311 10312 10321 10322 10320 10310 10319 10309 10329 10330',
apar: '10410 10420'
},
cores: { BR: 'BR', NG: 'FJ', FJ: 'FJ', FR: 'FJ', GR: 'GR', GF: 'GR', VD: 'VD', SL: 'RO', RO: 'RO', RS: 'RO' },
tampo60: '50388998815882', tampo80: '50388998848650', tampo50: '50388998881418',
prat60: { BR: '50389001896074', FJ: '50389001928842', GR: '50389001961610', RO: '50389001994378', VD: '50389002027146' },
prat80: { BR: '50389004550282', FJ: '50389004583050', GR: '50389004615818', RO: '50389004648586', VD: '50389004681354' },
mesa: { BR: '50389007073418', FJ: '50389007106186', GR: '50389007138954', RO: '50389007171722', VD: '50389007204490' },
ou: '50389009137802', cestos: '50389009301642', nichos: '50389009432714', algband: '50518997500042',
regras: {
solo60: [], solo80: [], solo50: [], msolo60: [], msolo80: [], combo60: [], combo80: [],
mil60: ['algband'], mil80: ['algband'], arm: ['algband'],
rack: ['nichos'], apar: ['nichos']
},
cort: { faixas: [150000, 250000], padrao: 'nichos,algband', op: {
nichos: { n: 'Kit 6 nichos freijó', v: [['50389009432714', 2]], img: IMG + 'kit-de-3-nichos-30cm-mdf-freijo-on-moveis-on-moveis-1195694990.png?v=1759338455&width=96' },
algband: { n: 'Porta-algodão e bandeja', v: [['50518997500042', 1]], img: IMG + '16765938-9dd5-467d-9c05-c4f4d9774130.png?v=1787749685&width=96', regra: 'algband' }
},
fim: [
{ n: 'Kit 2 prateleiras', img: IMG + 'kit-de-2-prateleiras-60cm-mdf-branco-on-moveis-on-moveis-1197570974.jpg?v=1760468717&width=96' },
{ n: 'Kit de organização', img: IMG + 'porta-sabonete-liquido-ou-linha-bold-on-moveis-1224689656.png?v=1772478368&width=96' },
{ n: '2 cestos', img: IMG + 'cesto-ou-6-6l-linha-flow-on-moveis-1224689652.png?v=1772478128&width=96' }
] },
velhos: ['ONSL-8RW4K', 'ONCT-P7M2Q', 'ONCT-N3X9H', 'ONCT-K5D8W', 'ONCT-C2V6T', 'SALACOMPLETA', 'BRINDE-SALA-COMPLETA', 'CORTESIA-PRATELEIRAS', 'CORTESIA-NICHOS', 'CORTESIA-ORGANIZACAO', 'CORTESIA-CESTOS', 'PCC-SALA-K7R2', 'PCC-C60-Q4M8', 'PCC-CNI-W9T3', 'PCC-COR-B5X6', 'PCC-CES-H2V7'],
inicio: '2026-10-07T00:00:00-03:00', fim: '2026-10-31T23:59:59-03:00'
};
var EH_BRINDE = {};
[C.tampo60, C.tampo80, C.tampo50, C.ou, C.cestos, C.nichos, C.algband].forEach(function (v) { EH_BRINDE[v] = 1; });
['prat60', 'prat80', 'mesa'].forEach(function (k) { Object.keys(C[k]).forEach(function (c) { EH_BRINDE[C[k][c]] = 1; }); });
var q = location.search;
if (/[?&]brindes=teste/.test(q)) try { sessionStorage.setItem('pccTeste', '1'); } catch (e) {}
var teste = false; try { teste = sessionStorage.getItem('pccTeste') === '1'; } catch (e) {}
var agora = Date.now();
var noPrazo = teste || (agora >= Date.parse(C.inicio) && agora <= Date.parse(C.fim));
var F = window.fetch.bind(window);
var J = { 'Content-Type': 'application/json', Accept: 'application/json' };
var ultimo = null, rodando = false, deNovo = false, timer = null, tentouCod = null, aberto = false;
var brinde = function (it) { return it.properties && it.properties._brinde; };
var reais = function (c) { return (c / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }); };
var GRUPO = {};
Object.keys(C.grupos).forEach(function (g) { C.grupos[g].split(' ').forEach(function (p) { GRUPO[p] = g; }); });
function classe(sku) {
sku = String(sku || '').toUpperCase();
var g = GRUPO[sku.slice(0, 5)]; if (!g) return null;
return [g, C.cores[sku.slice(-2)] || 'BR'];
}
function brindesDe(regra, cor) {
var b = C[regra]; if (typeof b === 'string') return [[b, 1]];
return [[b[cor] || b.BR, 1]];
}
var CORT = 'Cortesia';
function chave(it) { return (it.properties._brinde === CORT ? 'c:' : 'r:') + it.variant_id; }
var fora = function (it) { return /jantar|cadeira/i.test(it.product_type || ''); };
function calcula(cart) {
var quer = {}, sub = 0, regras = {};
var soma = function (k, n) { quer[k] = (quer[k] || 0) + n; };
if (!noPrazo) return { quer: quer, sala: false, n: 0, esc: [], ops: [], sub: 0, cod: [] };
cart.items.forEach(function (it) {
if (brinde(it) || EH_BRINDE[it.variant_id]) return;
sub += it.original_line_price;
var p = fora(it) ? null : classe(it.sku); if (!p) return;
(C.regras[p[0]] || []).forEach(function (r) {
regras[r] = 1;
brindesDe(r, p[1]).forEach(function (x) { soma('r:' + x[0], x[1] * it.quantity); });
});
});
var n = 0; C.cort.faixas.forEach(function (f) { if (sub >= f) n++; });
var ops = Object.keys(C.cort.op).filter(function (k) { var r = C.cort.op[k].regra; return !(r && regras[r]); });
var attr = (cart.attributes || {})._pcc_cortesias;
var bruto = attr == null ? C.cort.padrao : String(attr);
var esc = bruto.split(',').filter(function (k) { return ops.indexOf(k) > -1; }).slice(0, n);
esc.forEach(function (k) { C.cort.op[k].v.forEach(function (x) { soma('c:' + x[0], x[1]); }); });
return { quer: quer, sala: false, n: n, esc: esc, ops: ops, sub: sub, cod: [] };
}
function lerCaixa() { return F('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' }).then(function (r) { return r.json(); }); }
function sincroniza() {
if (rodando) { deNovo = true; return; }
rodando = true;
var mudou = false;
lerCaixa().then(function (cart) {
ultimo = cart;
var c = calcula(cart), tem = {}, upd = {}, add = [];
cart.items.forEach(function (it) {
if (!brinde(it)) { if (EH_BRINDE[it.variant_id]) upd[it.key] = 0; return; }
var k = chave(it), alvo = Math.max(0, (c.quer[k] || 0) - (tem[k] || 0));
var fica = Math.min(it.quantity, alvo);
tem[k] = (tem[k] || 0) + fica;
if (fica !== it.quantity) upd[it.key] = fica;
});
Object.keys(c.quer).forEach(function (k) {
var falta = c.quer[k] - (tem[k] || 0);
if (falta > 0) add.push({ id: +k.slice(2), quantity: falta, properties: { _brinde: k.charAt(0) === 'c' ? CORT : 'Por conta da casa' } });
});
var passos = Promise.resolve();
if (Object.keys(upd).length) { mudou = true; passos = passos.then(function () { return F('/cart/update.js', { method: 'POST', headers: J, body: JSON.stringify({ updates: upd }) }); }); }
if (add.length) { mudou = true; passos = passos.then(function () { return F('/cart/add.js', { method: 'POST', headers: J, body: JSON.stringify({ items: add }) }); }); }
var eh = function (k) { return C.velhos.indexOf(String(k).toUpperCase()) > -1; };
var codigos = (cart.discount_codes || []).filter(function (d) { return d.applicable !== false || eh(d.code); }).map(function (d) { return d.code; });
var atuais = codigos.filter(eh).map(function (k) { return String(k).toUpperCase(); }).sort().join(',');
if (atuais && tentouCod !== atuais) {
tentouCod = atuais;
mudou = true;
var novos = codigos.filter(function (k) { return !eh(k); });
passos = passos.then(function () { return F('/cart/update.js', { method: 'POST', headers: J, body: JSON.stringify({ discount: novos.join(',') }) }); });
}
return passos.then(function () { return mudou ? lerCaixa() : cart; }).then(function (fim) {
ultimo = fim;
var cc = calcula(fim);
if (mudou) redesenha();
painel(cc);
document.dispatchEvent(new CustomEvent('pcc:brindes', { detail: cc }));
});
}).catch(function () {}).then(function () {
rodando = false;
if (deNovo) { deNovo = false; setTimeout(sincroniza, 60); }
});
}
function agenda() { clearTimeout(timer); timer = setTimeout(sincroniza, 250); }
function redesenha() {
var g = document.getElementById('menuCaixa');
if (g && !g.hidden && g.childElementCount && window.ONM && ONM.carregaCaixa) ONM.carregaCaixa();
else if (document.body.classList.contains('t-cart')) location.reload();
}
var CART = new RegExp('/cart/(add|change|update|clear)');
window.fetch = function (u, o) {
var url = typeof u === 'string' ? u : (u && u.url) || '';
var p = F(u, o);
if (CART.test(url)) p.then(agenda, function () {});
return p;
};
try {
var xo = XMLHttpRequest.prototype.open;
XMLHttpRequest.prototype.open = function (m, url) {
if (CART.test(String(url))) this.addEventListener('loadend', agenda);
return xo.apply(this, arguments);
};
} catch (e) {}
try {
new PerformanceObserver(function (l) {
l.getEntries().forEach(function (en) { if (CART.test(en.name)) agenda(); });
}).observe({ type: 'resource', buffered: false });
} catch (e) {}
document.addEventListener('visibilitychange', function () { if (!document.hidden) agenda(); });
window.addEventListener('pageshow', function (e) { if (e.persisted) agenda(); });
var css = document.createElement('style');
css.textContent = '[data-pcc-painel]:empty{display:none}' +
'.pccx{margin:0 0 8px;padding:9px 12px;border-radius:14px;background:linear-gradient(160deg,#F1EBE2,#E4DACB);font-size:12.5px;line-height:1.4;color:#1C1C1C}.pccx b{font-weight:600}' +
'.pccx__l{display:flex;align-items:center;gap:10px;min-height:30px}.pccx__nm{flex:1;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}' +
'.pccx__fs{display:flex;flex:none}.pccx__fs img{width:30px;height:30px;border-radius:50%;object-fit:cover;background:#fff;border:2px solid #EFE8DE;margin-left:-9px}.pccx__fs img:first-child{margin-left:0}' +
'.pccx__k{font-size:10.5px;letter-spacing:.06em;text-transform:uppercase;font-weight:600;margin-right:6px}' +
'.pccx__tr{flex:none;font:inherit;font-size:12px;text-decoration:underline;text-underline-offset:3px;background:none;border:0;padding:4px 0;color:#1C1C1C;cursor:pointer}' +
'.pccx__es{flex:none;height:30px;padding:0 14px;border-radius:999px;border:0;background:#1C1C1C;color:#EFEFEF;font:inherit;font-size:12px;font-weight:600;cursor:pointer}' +
'.pccx__h{display:flex;align-items:center;justify-content:space-between;gap:10px;font-size:13px}' +
'.pccx__op{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:6px;margin:8px 0 2px}' +
'.pccx__op button{position:relative;display:flex;align-items:center;gap:10px;min-width:0;padding:5px 30px 5px 5px;border-radius:12px;border:1.5px solid transparent;background:rgba(255,255,255,.62);font:inherit;font-size:12px;line-height:1.25;text-align:left;color:#1C1C1C;cursor:pointer}' +
'.pccx__op button img{flex:none;width:52px;height:52px;border-radius:9px;object-fit:cover;background:#fff}.pccx__op button span{min-width:0}' +
'.pccx__op button[aria-pressed=true]{border-color:#1C1C1C;background:#fff}' +
'.pccx__op button[disabled]{cursor:default;padding-right:74px;background:rgba(255,255,255,.3);color:rgba(28,28,28,.5)}.pccx__op button[disabled] img{filter:grayscale(1);opacity:.5}' +
'.pccx__fim{position:absolute;top:50%;right:8px;transform:translateY(-50%);font-style:normal;font-size:9.5px;letter-spacing:.05em;text-transform:uppercase;font-weight:600;padding:3px 7px;border-radius:999px;background:#1C1C1C;color:#EFEFEF}' +
'.pccx__ck{position:absolute;top:50%;right:8px;transform:translateY(-50%);width:18px;height:18px;border-radius:50%;border:1.5px solid rgba(28,28,28,.25);display:grid;place-items:center;font-style:normal;font-size:11px;color:transparent}' +
'.pccx__op button[aria-pressed=true] .pccx__ck{background:#1C1C1C;border-color:#1C1C1C;color:#fff}' +
'.pccx__mt{color:rgba(28,28,28,.6);margin-top:6px;display:flex;align-items:center;gap:8px;font-size:12px}.pccx__bar{flex:1;height:2px;background:rgba(28,28,28,.1)}.pccx__bar i{display:block;height:100%;background:#1C1C1C}';
document.head.appendChild(css);
function painel(c) {
var lugar = document.querySelector('[data-pcc-painel]');
if (!lugar || !ultimo) return;
var temMovel = ultimo.items.some(function (it) { return !brinde(it) && !EH_BRINDE[it.variant_id]; });
if (!noPrazo || !temMovel || (c.n === 0 && c.sub < C.cort.faixas[0] * 0.5)) { lugar.innerHTML = ''; return; }
var falta = '';
if (c.n < C.cort.faixas.length) {
var alvo = C.cort.faixas[c.n], base = c.n ? C.cort.faixas[c.n - 1] : 0;
var pct = Math.max(4, Math.min(100, Math.round((c.sub - base) * 100 / (alvo - base))));
falta = `<div class='pccx__mt'><span>Faltam ${reais(alvo - c.sub)}${c.n ? ' para mais uma' : ''}</span><span class='pccx__bar'><i style='width:${pct}%'></i></span></div>`;
}
var quer = Math.min(c.n, c.ops.length), faltaEsc = quer - c.esc.length;
var h = `<div class='pccx'>`;
var cort = function (n) { return n === 1 ? '1 cortesia' : n + ' cortesias'; };
if (c.n > 0 && quer > 0 && faltaEsc <= 0 && !aberto) {
var nomes = c.esc.map(function (k) { return C.cort.op[k].n; }).join(', ');
var fotos = c.esc.map(function (k) { return `<img src='${C.cort.op[k].img}' alt='' width='30' height='30' loading='lazy'>`; }).join('');
h += `<div class='pccx__l'><span class='pccx__fs'>${fotos}</span><span class='pccx__nm'><span class='pccx__k'>Cortesia</span>${nomes}</span><button type='button' class='pccx__tr' data-pcc-abre>Trocar</button></div>`;
} else if (c.n > 0 && quer > 0 && !aberto) {
h += `<div class='pccx__l'><span class='pccx__nm'><b>Seu pedido ganhou ${cort(quer)}</b> por conta da casa</span><button type='button' class='pccx__es' data-pcc-abre>Escolher</button></div>`;
} else if (c.n > 0 && quer > 0) {
h += `<div class='pccx__h'><b>${c.esc.length && faltaEsc > 0 ? 'Escolha mais ' + faltaEsc : faltaEsc > 0 ? 'Escolha ' + cort(quer) : 'Suas cortesias'}</b><button type='button' class='pccx__tr' data-pcc-fecha>Fechar</button></div><div class='pccx__op'>`;
c.ops.forEach(function (k) {
var on = c.esc.indexOf(k) > -1;
h += `<button type='button' data-pcc-op='${k}' aria-pressed='${on}'><img src='${C.cort.op[k].img.replace('width=96', 'width=160')}' alt='' width='52' height='52' loading='lazy'><span>${C.cort.op[k].n}</span><i class='pccx__ck' aria-hidden='true'>✓</i></button>`;
});
C.cort.fim.forEach(function (x) {
h += `<button type='button' disabled aria-disabled='true'><img src='${x.img.replace('width=96', 'width=160')}' alt='' width='52' height='52' loading='lazy'><span>${x.n}</span><i class='pccx__fim'>Esgotado</i></button>`;
});
h += `</div>` + falta;
} else {
h += `<div><b>Compre e ganhe:</b> acima de ${reais(C.cort.faixas[0])} tem cortesia</div>` + falta;
}
lugar.innerHTML = h + '</div>';
}
document.addEventListener('click', function (e) {
if (!e.target.closest) return;
if (e.target.closest('[data-pcc-abre]')) { e.preventDefault(); aberto = true; if (ultimo) painel(calcula(ultimo)); }
else if (e.target.closest('[data-pcc-fecha]')) { e.preventDefault(); aberto = false; if (ultimo) painel(calcula(ultimo)); }
});
document.addEventListener('click', function (e) {
var b = e.target.closest && e.target.closest('[data-pcc-op]');
if (!b || !ultimo) return;
e.preventDefault();
var c = calcula(ultimo), k = b.dataset.pccOp, esc = c.esc.slice();
var i = esc.indexOf(k);
if (i > -1) esc.splice(i, 1); else { esc.push(k); if (esc.length > c.n) esc.shift(); }
if (esc.length >= Math.min(c.n, c.ops.length)) aberto = false;
F('/cart/update.js', { method: 'POST', headers: J, body: JSON.stringify({ attributes: { _pcc_cortesias: esc.join(',') } }) }).then(function () { deNovo = false; return sincroniza(); });
setTimeout(redesenha, 900);
});
function freteCurto() {
var t = document.querySelectorAll('[data-fretebar-txt]');
for (var i = 0; i < t.length; i++) {
var x = t[i].textContent;
if (/^Frete gr[áa]tis/i.test(x) && /Demais estados/i.test(x) && x !== 'Frete grátis para todo o Brasil') t[i].textContent = 'Frete grátis para todo o Brasil';
}
}
if (window.MutationObserver) {
new MutationObserver(freteCurto).observe(document.body, { childList: true, subtree: true, characterData: true });
new MutationObserver(function () {
var l = document.querySelector('[data-pcc-painel]');
if (l && !l.firstChild && !l.dataset.pccVisto) {
l.dataset.pccVisto = '1';
if (ultimo) painel(calcula(ultimo));
agenda();
}
}).observe(document.body, { childList: true, subtree: true });
}
var tpl = noPrazo && document.getElementById('pccPdp');
if (tpl && tpl.content) {
var alvoP = document.querySelector('.pr__l2');
var bloco = alvoP && (alvoP.closest('.pr') || alvoP.parentElement);
var depois = bloco && bloco.nextElementSibling && bloco.nextElementSibling.classList.contains('ship') ? bloco.nextElementSibling : bloco;
if (depois && depois.parentNode) depois.parentNode.insertBefore(tpl.content.cloneNode(true), depois.nextSibling);
}
sincroniza();
window.ONM = window.ONM || {};
window.ONM.brindes = { sincroniza: sincroniza, calcula: calcula, config: C };
})();
